// import Vue from 'vue'
import { createStore } from 'vuex'
import {
	setUserInfoStorage,
	getUserInfoStorage,
	getJsessionId
} from "@/service/storage"
import $api from "../utils/api.js"
const user = getUserInfoStorage()
const userId = getJsessionId()
// Vue.use(Vuex)
let globalPromise = null
const store = createStore({
	state: {
		hasLogin: false,
		openid: '',
		userInfo: user || {},
		orderId: Number,
		userId: userId || '',
		latitude: '',// 纬度
		longitude: '', // 经度
		address: "",
		status: '',
		withdrawType: '', // 提现类型
		total_money: '', // 账户总额
		fail: "",
		isUpdateText:false,//是否有传新版本
		downloadApkUrl:'',//安装包地址
		contentText:"",//版本更新内容
		versionNum:"",//当前版本号
		orderIds: []
	},
	getters: {
		openid: state => state.openid,
		address: state => state.address,
		userInfo: state => state.userInfo,
	},
	mutations: {
		login(state) {
			state.hasLogin = true;
		},
		
		setOpenId(state, openid) {
			state.openid = openid
		},
		setUserInfo(state, userInfo) {
			state.userInfo = userInfo
		},
		setToken(state, token) {
			state.token = token
		},
		clear(state){
			state.userInfo = {}
			state.userId = ''
		},
		setDownloadApkUrl(state,downloadApkUrl){
			state.downloadApkUrl = downloadApkUrl
		},
		setVersionNum(state,versionNum){
			state.versionNum = versionNum
		},
		setContent(state,contentText){
			state.contentText = contentText
		},
		setIsUpdateText(state,isUpdateText){
			state.isUpdateText = isUpdateText
		},
		UPDATE_LOCATION (state, res) {
			state.latitude = res.latitude
			state.longitude = res.longitude
			state.address  = res.address || `经纬度：${res.latitude},${res.longitude}`
			
			console.log('app.vue定位地址：', state.address)
		}
	},
	actions: {
		async login(context, query = false) {
			let reFresh = false
			let openid = ''
			if (typeof query == 'boolean') {
				reFresh = query
			} else {
				reFresh = query.isrefresh
				openid = query.openid
			}
			if (reFresh) {
				globalPromise = null
			}
			if (globalPromise !== null) {
				console.log('vuex login has GlobalPromise')
				return globalPromise
			}
			console.log('vuex login start', openid)
			const fn = async () => {
				try {
					uni.showLoading({
						title: 'Loading'
					})
					console.log('vuex login GlobalPromise')
					const [error, res] = await uni.login({
						provider: 'weixin'
					});
					if (error) {
						uni.hideLoading()
						return;
					}
					console.log('login code:', res.code)
					const [err, res1] = await login({
						code: res.code,
						openid_x: openid
					})
					uni.hideLoading()
					if (err) {
						return
					}
					context.commit('login')
					context.commit('setOpenId', res1.data.openid)
					context.commit('setUserInfo', res1.data.userinfo)

					setUserInfoStorage(res1.data.userinfo)
					return res1.data.userinfo

				} catch (e) {
					uni.hideLoading()
					globalPromise = null
					return e
				}
			}
			globalPromise = fn()
			// 接口请求报错过后重置globalPromise 下次继续发送正常请求
			globalPromise.catch(() => {
				globalPromise = null
			})
			return globalPromise
		},
		async getUserInfo(context, id) {
			// 获取用户信息
			const [err1, user] = await $api.myInfo({
				id: id || context.state.userId,
			})
			if (err1 || (user && user.code !== 10000)) {
				return false
			}
			if (user.data.status == 0) {
				uni.showToast({
					title: "技师已下架",
					icon: "error"
				})
				uni.clearStorage()
				setTimeout(() => {
					uni.reLaunch({
						url: "/pages/login/login"
					})
				},2000)
			}
			if(user.data.img_state == 'refused') {
				// this.$toast('已拒绝')
				user.data.stateText = '已拒绝'
			} else if(user.data.img_state == 'pending') {
				// this.$toast('待审核')
				user.data.stateText = '待审核'
			} else {
				user.data.stateText = '已审核'
			}
		
			setUserInfoStorage(user.data)
			console.log('获取用户信息')
			context.commit('setUserInfo', user.data)
			return user.data
		},
		async location(context, map) {
			if (!context.state.userInfo || !context.state.userInfo.id) return
			const params = {
				id: context.state.userInfo.id,
				latitude: map.latitude,
				longitude: map.longitude,
				address: map.address || "",
				is_virtual: map.is_virtual || 0
			}
			const [err, res] = await $api.info(params)
			if (err || res.code !== 10000) return uni.showToast({
					title: (res && res.msg) || '后台更新地址失败',
					icon: 'none'
				})
			if(res.code == 10000){
				context.commit("UPDATE_LOCATION", params)
			}
		},
	}
})

export default store
